import Table from '../../Utils/Grid';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { api } from "api";

import { BreakLine } from '../../Utils/tableOptions';
import '../../whearhouse/administration/whearhouse';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import {
    renderField,
    renderSearchSelect,
    renderDatePicker,
    modalTextArea,
    dateInput
} from '../../Utils/renderField/renderField';
import ToolbarTab from '../../Utils/Toolbar/ToolbarTab';
import { BootstrapTable } from 'react-bootstrap-table';

import { RenderCurrency } from  '../../Utils/renderField/renderReadField';
import DatePicker from '../../Utils/DatePicker/datePickerCustom';
import NumberFormat from 'react-number-format';
import { connect } from 'react-redux'
import MyModal from '../../Utils/myModal';
import PaymentForm from '../payment/paymentForm';

import '../purchase_order.css';

let providers=[];
const getProviders = (search)  =>{
    return api.get("providers/", {search}).catch((error) => {})
        .then((data) => {
            if(data){
                providers = [];
                data.results.forEach(x=>{
                    providers.push({value: x.id, label: x.name})
                })
                return providers;
            }
            else{
                return [];
            }
        })
        .catch(e => {
            return [];
        })
}

let spendings = []
const getSpendingTypes = (search)  =>{
    return api.get("spending_type",{search}).catch((error) => {})
        .then((data) => {
            if (data){
                spendings = [];
                data.results.forEach(x=>{
                    spendings.push({value: x.id, label: x.name})
                })
                return spendings;
            }
            else{
                return []
            }
        })
        .catch(e => {
            return []
        })
}

class NuevaOrden extends Component {
    componentWillMount() {
        if(this.props.match.params.id){
            this.props.getPurchaseOrder(this.props.match.params.id);
        }

        this.props.listarServicios();

        const {
            initializeOrderForm
        } = this.props;

        initializeOrderForm();
    }

    addToCar = (data, row, cell) => {
        return(
            <button onClick={() => {this.props.addServiceToListOrder(row)}} className="circle-button-car">
                 <img className="card-img-top d-block" src={require("../../../../../assets/img/icons/add-icon-blue.png")} alt="Add icon" />
            </button>
        );
    }

    deleteFormatter = (row, cell, enumObject, index) => {
       return (<button onClick={()=>this.props.removeServiceToList(index)} className="circle-button-delete">
                    <img className="card-img-top d-block" src={require("../../../../../assets/img/icons/delete-patient-icon.png")} alt="Delete icon" />
                </button>);
    }

    cantidadFormatter = (cell, row, enumObject, index) => {
        const id = row.id;
        const cant = row.cantidad;

        return(
            <React.Fragment>
                <div className="group-button-up-down">
                    <button className="button-content left-tab" onClick={() => {this.props.upDownCantOrder(index, false)}}>
                        <img className="card-img-top d-block arrow-button" id="arrow-button-toggle" src={require("../../../../../assets/img/icons/down-arrow-white-icon.png")} alt="CashBox image" />
                    </button>
                    <NumberFormat className="input-cant text-left" decimalScale={0} value={cant} onValueChange={({value}) => {
                        this.props.setCantOrder(index, value)
                    }} />
                    <button className="button-content right-tab" onClick={() => {this.props.upDownCantOrder(index, true)}}>
                        <img className="card-img-top d-block arrow-button" id="arrow-button-toggle" src={require("../../../../../assets/img/icons/up-arrow-white-icon.png")} alt="CashBox image" />
                    </button>
                </div>
            </React.Fragment>
        );
    }

    precioFormatter = (cell, row, enumObject, index) => {
        const id = row.id;
        const precio = row.precio;

        console.log("Row en la orden: ", row);

        return(
            <React.Fragment>
                <NumberFormat value={precio} prefix='Q ' thousandSeparator={true} className="oc_costo"
                    decimalScale={3}
                    onValueChange={(values) => {
                        const {value} = values;
                        const valor = (value === '') ? 0 : value;
                        this.props.setPrice(index, valor);
                    }}
                />
            </React.Fragment>
        );
    }

    subtotalFormatter = (cell, row) => {
        return <RenderCurrency value={cell}/>;
    }

    barcodeFormatter = (cell) => {
        return <span className="barcode-service-list">{cell}</span>
    }

    setConsignment = (cell, row, enumObject, index) => {
        return(
            <React.Fragment>
                <div className='text-center'>
                    <input
                        type="checkbox"
                        defaultChecked={cell}
                        style={{WebkitAppearance:"Checkbox"}}
                        onClick={()=>this.props.setConsignmentAuthorization(index)}
                    />
                </div>
            </React.Fragment>
        );
    }

    render() {
        const {
            listarServicios,
            purchaseAuthorization,
        } = this.props;


        const {
            id_purchase_order,
            data_service,
            cargando,
            page_service,
            cargando_service,
            total_in_list,
            order_state,
        } = this.props;

        console.log("PROPS EN ADMIN PURCHASE ORDER: ", this.props);

        return (
            <React.Fragment>
            <div className="content-with-tabs">
                    <div className="table-decoration row mx-5 mt-3 mb-3 d-flex">
                        <div className="row-fluid w-100 mt-2 mb-1">

                        <form className="py-3 px-3" name="in-bodega" id="in-bodega">
                            <div className="px-md-5 d-flex justify-content-around flex-column flex-sm-row align-items-stretch align-items-sm-center w-100">
                                <div className="m-2 w-25">
                                    <div className="d-flex justify-content-start flex-column flex-sm-row align-items-stretch align-items-sm-center">
                                        <label htmlFor="provider" className="m-0">Proveedor</label>
                                    </div>
                                    <div className=" d-flex justify-content-start flex-column flex-sm-row align-items-stretch align-items-sm-center">
                                        <Field
                                            name="provider"
                                            valueKey="value"
                                            labelKey="label"
                                            label="provider"
                                            component={renderSearchSelect}
                                            loadOptions={getProviders}
                                            className="no-border"
                                            autofocus
                                        />
                                    </div>
                                </div>

                                <div className="m-2">
                                    <div className="d-flex justify-content-start flex-column flex-sm-row align-items-stretch align-items-sm-center">
                                        <label htmlFor="date" className="m-0">Fecha</label>
                                    </div>
                                    <div className=" d-flex justify-content-end flex-column flex-sm-row align-items-stretch align-items-sm-center">
                                        <Field name="date" component={dateInput} type="text" className="form-control" />
                                    </div>
                                </div>
                            </div>

                            <div className="px-md-5 d-flex justify-content-around flex-column flex-sm-row align-items-stretch align-items-sm-center w-100">
                                <div className="m-2  w-70">
                                    <div className="d-flex justify-content-start flex-column flex-sm-row align-items-stretch align-items-sm-center">
                                        <label htmlFor="spending_type" className="m-0">Tipo de gasto</label>
                                    </div>
                                    <div className=" d-flex justify-content-start flex-column flex-sm-row align-items-stretch align-items-sm-center">
                                        <Field
                                            name="spending_type"
                                            valueKey="value"
                                            labelKey="label"
                                            label="spending_type"
                                            component={renderSearchSelect}
                                            loadOptions={getSpendingTypes}
                                            className="no-border"
                                            autoFocus
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="px-md-5 d-flex justify-content-around flex-column flex-sm-row align-items-stretch align-items-sm-center w-100">
                                <div className="m-2 w-70">
                                    <div className="d-flex justify-content-start flex-column flex-sm-row align-items-stretch align-items-sm-center">
                                        <label htmlFor="note" className="m-0">Anotaciones u otros comentarios</label>
                                    </div>
                                    <Field
                                        name="note"
                                        valueKey="value"
                                        labelKey="label"
                                        component={modalTextArea}
                                        className="ingreso-textarea"
                                    />
                                </div>
                            </div>
                        </form>
                        </div>
                    </div>


                <div className="table-decoration w-50 h-100 mx-5 ml-5 d-flex flex-column sales-services" id="left-tab-bodega">
                    <div className="fields">

                        <div className="m-auto row-fluid w-100 h-100">
                            <div className="table-decoration rcp-table-decoration" id="comodin-table">
                                <div className="pl-3 pr-3 d-flex flex-wrap h-25 justify-content-start align-items-center">
                                    <div className="d-flex pb-2 flex-column w-50 justify-content-center align-items-center">
                                        <div className="d-inline-flex w-100 pt-3 justify-content-start service-title">
                                            LISTADO DE SERVICIOS
                                        </div>
                                        <ToolbarTab
                                            id="toolbar-tab"
                                            buscar={this.props.searchService}
                                            buscador={this.props.buscador_service}
                                        />
                                    </div>

                                        <div className="table-responsive">
                                            <Table
                                                onPageChange={listarServicios}
                                                data={data_service}
                                                loading={cargando_service}
                                                page={page_service}
                                                maxHeight={370}
                                            >

                                            <TableHeaderColumn
                                                tdStyle={BreakLine}
                                                thStyle={BreakLine}
                                                dataField="name"
                                                dataSort
                                                >Servicio</TableHeaderColumn>

                                            <TableHeaderColumn
                                                tdStyle={BreakLine}
                                                thStyle={BreakLine}
                                                dataField="barcode"
                                                dataSort
                                                dataFormat={this.barcodeFormatter}
                                                >Código de Barras</TableHeaderColumn>

                                            <TableHeaderColumn
                                                dataField="id"
                                                isKey={true}
                                                dataAlign="center"
                                                dataFormat={this.addToCar}
                                                ></TableHeaderColumn>
                                            </Table>
                                        </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="table-decoration h-100  align-items-around d-flex flex-column sales-services" id="right-tab-bodega">
                    <div className="table-responsive-sm">
                        <BootstrapTable data={this.props.productsInList}
                            maxHeight={350}
                            minHeight={350}
                            trClassName="customClass"
                        >
                            <TableHeaderColumn width='170' dataField='name'>Producto</TableHeaderColumn>
                            <TableHeaderColumn width='100' dataField='cantidad'
                                dataFormat={this.cantidadFormatter}
                            >Cantidad</TableHeaderColumn>

                            <TableHeaderColumn width='100' dataField='precio'
                                dataFormat={this.precioFormatter}
                            >Costo</TableHeaderColumn>

                            <TableHeaderColumn width='100' dataField='total'
                                dataFormat={this.subtotalFormatter}
                            >Subtotal</TableHeaderColumn>

                            <TableHeaderColumn width='100' dataField='consignment'
                                dataFormat={this.setConsignment}
                            >Consignación</TableHeaderColumn>

                            <TableHeaderColumn width='50' dataField='id' isKey
                                dataFormat={this.deleteFormatter}
                            >
                            </TableHeaderColumn>
                        </BootstrapTable>
                    </div>

                    {this.props.total_in_list > 0 &&
                    <div className="d-flex justify-content-end align-items-center p-3 bodega-ingreso-footer justify-content-evenly">
                        <div className="d-flex element-footer-bodega">Monto Total</div>
                        <div className="d-flex element-footer-bodega"><RenderCurrency value={total_in_list.toFixed(2)} /></div>
                    </div>
                    }

                    <div className="d-flex flex-row justify-content-end align-items-start h-100 pr-5 pt-3">
                        <div onClick={()=>this.props.cancelOrder('/orders-adm')} className="d-flex justify-content-top align-items-center flex-column mr-2 oc-icon-content oc_icon_gris">
                            <img className="oc_icon" title="Regresar" src={require("../../../../../assets/img/icons/return-icon-white.png")} alt="Regresar" />
                            <span className="oc-text-icon">Cancelar</span>
                        </div>
                        {(this.props.order_state != 3 ) && (
                            <React.Fragment>
                                <div onClick={() => this.props.updateOrder('/orders-adm',undefined, false)} className="d-flex justify-content-top align-items-center flex-column mr-2 oc-icon-content oc_icon_azul">
                                    <img className="oc_icon" title="Guardar" src={require("../../../../../assets/img/icons/save-icon-white.png")} alt="Guardar" />
                                    <span className="oc-text-icon">{(id_purchase_order > 0) ? "Guardar" : "Generar"}</span>
                                </div>

                                <div onClick={() => this.props.updateOrder('/orders-adm')} className="d-flex justify-content-top align-items-center flex-column mr-2 oc-icon-content  oc_icon_verde">
                                    <img className="oc_icon" title="Autorizar" src={require("../../../../../assets/img/icons/check-patient-icon.png")} alt="Autorizar" />
                                    <span className="oc-text-icon">Autorizar</span>
                                </div>

                                <div className="d-flex justify-content-top align-items-center flex-column mr-2 oc-icon-content  oc_icon_azul_2">
                                    <MyModal isOpen={false}
                                        title="MÉTODOS DE PAGO"
                                        formId="form_payment"
                                        imageButton={<img className="oc_icon" title="Autorizar y pagar" src={require("../../../../../assets/img/icons/check-patient-icon.png")} alt="Autorizar y pagar" />}
                                        classToggleButton="d-block h-100 button-service-icon"
                                        body={
                                            <PaymentForm
                                                total={total_in_list.toFixed(2)}
                                                onSubmit={this.props.updateOrder}
                                                id_purchase={this.props.match.params.id}
                                                retiene={this.props.provider ? this.props.provider.retention : null}
                                                provider={this.props.provider ? this.props.provider: null}
                                                url_retorno={'/orders-adm'}
                                            />
                                        }
                                    />
                                    <span className="oc-text-icon">Autorizar</span>
                                    <span className="oc-text-icon">y pagar</span>
                                </div>
                                <div  onClick={() => purchaseAuthorization(false)} className="d-flex justify-content-top align-items-center flex-column mr-2 oc-icon-content oc_icon_rojo">
                                    <img className="oc_icon" title="Rechazar" src={require("../../../../../assets/img/icons/cancel-icon-white.png")} alt="Rechazar" />
                                    <span className="oc-text-icon">Rechazar</span>
                                </div>
                            </React.Fragment>
                        )
                        }



                    </div>

                    {/*
                    <div className="d-flex flex-row justify-content-end align-items-center h-100 pr-5">
                        <button className="btn btn-secondary btn-sm" onClick={()=>this.props.cancelOrder('/orders-adm')}>Cancelar</button>
                        {this.props.productsInList.length > 0 && form_validate ?
                            <button type="button" className="btn btn-primary btn-sm ml-2"
                                onClick={(id_purchase_order > 0) ? updateOrder : sentOrder}
                            >{(id_purchase_order > 0) ? "Guardar Orden" : "Generar Orden"}</button>
                            :
                            <button className="btn btn-primary btn-sm ml-2 disabled">{(id_purchase_order > 0) ? "Guardar Orden" : "Generar Orden"}</button>
                        }

                        <button className="btn btn-primary btn-sm ml-2">Autorizar</button>
                        <button className="btn btn-secondary btn-sm ml-2">Rechazar</button>
                    </div>
                    */}
                </div>
            </div>
            </React.Fragment>
        )
    }
}

NuevaOrden = reduxForm({
    form: 'nuevaOrden',

   validate: data => {
    const errors={};

     if(!data.provider){
         errors.provider = 'Campo requerido';
     }

     if(data.provider == null){
        errors.provider = 'Campo requerido';
     }

     if(!data.document_number){
         errors.document_number = 'Campo requerido';
     }

     return errors;
    }
 })(NuevaOrden);

const selector = formValueSelector('nuevaOrden');

NuevaOrden = connect(state => {
    let form_validate = true;


    const provider = selector(state, "provider")
    const date = selector(state, "date");
    if(provider === undefined || provider === null){
        form_validate = false;
    }

    if(date === undefined || provider === null){
        form_validate = false;
    }

    return {
        form_validate
    };

})(NuevaOrden);

export default NuevaOrden;
